const NoticeLayout = () => import('@/layout/noticeLayout.vue');

export const noticeWhitelist = ['/notice'];

export default {
    path: '/notice',
    component: NoticeLayout,
    meta: {
        title: 'Notice Center',
        i18n: 'route.notice',
        hideHeader: true,
    },
    redirect: '/notice/index',
    children: [
        {
            path: 'index',
            name: 'noticeCenter',
            component: () => import('@/views/notice/index.vue'),
            meta: {
                title: 'Notice Center',
                i18n: 'route.noticeCenter',
            },
        },
    ],
};
